<template>
  <div class="rewards">
    <ag-table :data-source-api="getAllReward" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onCreateReward()" />
    <tm-popup :submit="onRewardPopupSubmit" :title="rewardPopupTitle" ref="rewardPopup">
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="اسم المكافأة" placeholder="اسم المكافأة" type="text"
            validation-rules="required" v-model="reward.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="كود المكافأة" placeholder="كود المكافأة" type="text"
            validation-rules="required" v-model="reward.code" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="عدد النقاط" placeholder="عدد النقاط" type="number" validation-rules="required"
            v-model="reward.points" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getRewardStatusOptions" label="name" validation-rules="required"
            name="حالة المستوى" :reduce="name => name.value" v-model="reward.status" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "../../../shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import FilePondComponent from "@/app/shared/shared-components/FilePondComponent";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TmSelect from "@/app/shared/shared-components/TmSelect";

const rewardsRepo = RepositoryFactory.get('rewardsRepository');
export default {
  name: "Rewards",
  components: {
    AgTable,
    TmInput,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmTextArea,
    FilePondComponent,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      rewardPopupTitle: '',
      status: {
        active: 'فعّال',
        inactive: 'معطّل',
      },
      reward: {
        name: null,
        points: null,
        code: null,
        status: 'active',
      },
      permissions: {
          add: 'rewards_manage',
          edit: 'rewards_manage',
          delete: 'rewards_manage',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'اسم المكافأة',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'كود المكافأة',
          field: 'code',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'عدد النقاط',
          field: 'points',
          filter: 'agNumberColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'حالة المكافأة',
          field: 'status',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return self.status[params.data.status] || '-';
            },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: value => self.status[value]
          }
        },
        {
          headerName: 'الإجراءات',
          field: 'id',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            deleteRecord: function (id) {
              self.onDeleteReward(id);
            },
            editRecord: function (reward) {
              self.onUpdateReward(reward);
            },
            actions: ['edit', 'delete'],
            permissions: self.permissions
          },
        }
      ];
    },
    async onDeleteReward(rewardId) {
      await rewardsRepo.removeReward(rewardId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },

    onUpdateReward(reward) {
      this.rewardPopupTitle = 'تعديل معلومات المستوى';
      this.resetRewardForm();
      Object.assign(this.reward, reward);
      this.$refs.rewardPopup.open();
    },
    onCreateReward() {
      this.rewardPopupTitle = 'إضافة مستوى جديد';
      this.resetRewardForm();
      this.$refs.rewardPopup.open();
    },
    resetRewardForm() {
      Object.assign(this.reward, {
        name: null,
        points: null,
        code: null,
        status: 'active',
      });
    },
    async onRewardPopupSubmit() {
      try {
        let res = null;
        const rewardPayload = {
          ...this.reward,
          points: parseInt(this.reward.points)
        };
        if (this.rewardPopupTitle == 'إضافة مستوى جديد') {
          res = await rewardsRepo.createReward(rewardPayload);
        } else {
          res = await rewardsRepo.updateReward(rewardPayload);
        }

        if (res.status === 201 || res.status === 200) {
          this.$refs.rewardPopup.close();
          await this.gridApi.refreshServerSideStore({ purge: true });
        }
      } catch (err) {
        this.$refs.rewardPopup.endLoading();
      }
    },
    async getAllReward(query) {
      return await rewardsRepo.fetchRewards(query);
    },
  },
  computed: {
    getRewardStatusOptions() {
      return Object.keys(this.status).map(key => ({
        name: this.status[key],
        value: key
      }));
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>